/* profiles-ui.js — Conformité : choix du profil, verdict, détail par règle, et
 * gestion des profils personnels (localStorage). Expose window.ProfilesUI. */
(function () {
  'use strict';

  var R = window.MediaRules;
  var BUILTIN = (window.MediaProfiles && window.MediaProfiles.PROFILES) || [];
  var F = window.MediaFormat;
  var K = window.MediaFindings;
  var LS_KEY = 'analyseur-media.customProfiles.v1';

  var custom = load();
  var selectedId = null;
  var model = null;
  var lastReport = null;
  var listeners = [];

  var el = {};
  function $(id) { return document.getElementById(id); }

  function load() { try { var s = localStorage.getItem(LS_KEY); return s ? JSON.parse(s) : []; } catch (_) { return []; } }
  function save() { try { localStorage.setItem(LS_KEY, JSON.stringify(custom)); } catch (_) {} }

  function allProfiles() { return BUILTIN.concat(custom); }
  function byId(id) { var a = allProfiles(); for (var i = 0; i < a.length; i++) if (a[i].id === id) return a[i]; return null; }
  function isCustom(id) { for (var i = 0; i < custom.length; i++) if (custom[i].id === id) return true; return false; }

  /* ---------- Sélecteur ---------- */
  function populate() {
    var sel = el.select;
    sel.innerHTML = '';
    var none = document.createElement('option');
    none.value = ''; none.textContent = '— Aucun usage choisi —';
    sel.appendChild(none);
    function group(label, list) {
      if (!list.length) return;
      var og = document.createElement('optgroup'); og.label = label;
      list.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p.id;
        o.textContent = p.name + (p.statut ? ' · ' + p.statut : '');
        og.appendChild(o);
      });
      sel.appendChild(og);
    }
    // les profils livrés sont rangés par famille
    Object.keys(R.FAMILIES).forEach(function (f) {
      group(R.FAMILIES[f], BUILTIN.filter(function (p) { return p.family === f; }));
    });
    group('Autres', BUILTIN.filter(function (p) { return !p.family || !R.FAMILIES[p.family]; }));
    group('Mes profils', custom);
    sel.value = selectedId || '';
  }

  /* ---------- Rendu du verdict ---------- */
  function evaluateAndRender() {
    var host = el.verdict;
    var p = selectedId ? byId(selectedId) : null;
    if (!p || !model) {
      host.innerHTML = model ? '<p class="gap-scope">' + F.esc(K.LABELS.usageNone) + '</p>' : '';
      lastReport = null; updateButtons(); notify(); return;
    }

    var rep = R.evaluate(p, model);
    lastReport = rep;
    var v = rep.verdict;

    var meta = 'profil ' + F.esc(p.id) + ' v' + F.esc(p.version || '?') +
      (p.date ? ' (' + F.esc(p.date) + ')' : '') + ' · moteur v' + F.esc(rep.engine) +
      (p.statut ? ' · ' + F.esc(p.statut) : '');

    var head = '<div class="vlabel"><span class="vdot"></span>' + F.esc(v.label) + '</div>' +
      '<div class="vmeta">' + meta + '</div>' +
      (p.description ? '<p class="vdesc">' + F.esc(p.description) + '</p>' : '') +
      (p.notChecked && p.notChecked.length ? '<details class="rules-quiet vnot"><summary>' + F.esc(K.LABELS.notChecked) + ' · ' + p.notChecked.length +
        '</summary><ul class="rulelist">' + p.notChecked.map(function (n) { return '<li><span class="rmark unevaluable" aria-hidden="true">–</span><span>' + F.esc(n) + '</span></li>'; }).join('') + '</ul></details>' : '') +
      (p.sources && p.sources.length ? '<details class="rules-quiet vsources"><summary>' + F.esc(K.LABELS.sources) + ' · ' + p.sources.length + '</summary><ul class="rulelist">' +
        p.sources.map(function (s) {
          return '<li><a href="' + F.esc(s.url) + '" target="_blank" rel="noopener">' + F.esc(s.title) + '</a>' +
            (s.consulted ? ' <span class="robs">(' + F.esc(K.fill(K.LABELS.consulted, { date: s.consulted })) + ')</span>' : '') + '</li>';
        }).join('') + '</ul></details>' : '');

    var body = '';
    if (!rep.applicable.ok) {
      body = '<p class="robs" style="margin-top:10px">' + F.esc(rep.applicable.reason) + '</p>';
    } else {
      // les règles en écart sont listées avec les écarts ; ici, le reste
      var q = F.quietRules(rep);
      body = quietList(q.unevaluable, 'unevaluable', '?', K.LABELS.rulesUnevaluable, v.code === 'indeterminate') +
        quietList(q.passed, 'pass', '✓', K.LABELS.rulesPassed, false) +
        quietList(q.notApplicable, 'unevaluable', '–', K.LABELS.rulesNotApplicable, false);
    }

    host.innerHTML = '<div class="verdict ' + v.code + '">' + head + body + '</div>';
    updateButtons();
    notify();
  }

  function quietList(lines, status, mark, label, open) {
    if (!lines.length) return '';
    var items = lines.map(function (r) {
      var obs = r.observed ? ' <span class="robs">(' + F.esc(r.observed) + ')</span>' : '';
      return '<li><span class="rmark ' + status + '" aria-hidden="true">' + mark + '</span>' +
        '<span>' + F.esc(r.message) + obs + '</span></li>';
    }).join('');
    return '<details class="rules-quiet"' + (open ? ' open' : '') + '><summary>' + F.esc(label) + ' · ' + lines.length +
      '</summary><ul class="rulelist">' + items + '</ul></details>';
  }

  function notify() { listeners.forEach(function (fn) { fn(lastReport); }); }

  /* ---------- Boutons de gestion ---------- */
  function updateButtons() {
    var has = !!selectedId && !!byId(selectedId);
    el.dup.disabled = !has;
    el.export.disabled = !has;
  }

  function openEditor(obj, msg) {
    el.editor.hidden = false;
    var d = el.editor.closest('details'); if (d) d.open = true;
    el.json.value = JSON.stringify(obj, null, 2);
    setMsg(msg || 'Éditez le JSON puis Enregistrer.', false);
    el.json.focus();
  }
  function closeEditor() { el.editor.hidden = true; setMsg('', false); }
  function setMsg(m, isErr) { el.msg.textContent = m; el.msg.classList.toggle('error', !!isErr); }

  function uniqueId(base) {
    var id = base, n = 2;
    while (byId(id)) { id = base + '-' + n; n++; }
    return id;
  }

  function newProfile() {
    var tpl = {
      id: uniqueId('mon-profil'), name: 'Mon profil', version: '1.0.0', date: today(), statut: 'gabarit',
      description: '', appliesTo: { requireTracks: {} },
      rules: [{ id: 'exemple', track: 'audio', quantifier: 'all', field: 'samplingRate', op: 'inList', value: [44100, 48000], severity: 'error', message: 'Fréquence attendue : 44,1 ou 48 kHz.' }]
    };
    openEditor(tpl, 'Nouveau profil — adaptez puis Enregistrer.');
  }

  function duplicate() {
    var p = byId(selectedId); if (!p) return;
    var copy = JSON.parse(JSON.stringify(p));
    copy.id = uniqueId(p.id + '-copie');
    copy.name = p.name.replace(/\s*\(gabarit\)$/, '') + ' (copie)';
    copy.statut = 'gabarit';
    openEditor(copy, 'Copie de « ' + p.name + ' » — ajustez puis Enregistrer.');
  }

  function saveEdited() {
    var obj;
    try { obj = JSON.parse(el.json.value); }
    catch (e) { setMsg('JSON invalide : ' + e.message, true); return; }
    var err = R.validateProfile(obj);
    if (err) { setMsg(err, true); return; }
    var idx = -1;
    for (var i = 0; i < custom.length; i++) if (custom[i].id === obj.id) idx = i;
    if (idx >= 0) custom[idx] = obj; else custom.push(obj);
    save();
    selectedId = obj.id;
    populate();
    closeEditor();
    evaluateAndRender();
  }

  function exportProfile() {
    var p = byId(selectedId); if (!p) return;
    var blob = new Blob([JSON.stringify(p, null, 2)], { type: 'application/json' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = p.id + '.json';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 5000);
  }

  function importProfile(file) {
    var reader = new FileReader();
    reader.onload = function () {
      var obj;
      try { obj = JSON.parse(reader.result); }
      catch (e) { openEditor({}, ''); setMsg('Import : JSON invalide (' + e.message + ').', true); return; }
      var err = R.validateProfile(obj);
      if (err) { openEditor(obj, 'Import : ' + err + ' Corrigez puis Enregistrer.'); return; }
      if (byId(obj.id) && !isCustom(obj.id)) obj.id = uniqueId(obj.id + '-importe');
      openEditor(obj, 'Profil importé — vérifiez puis Enregistrer pour l’ajouter.');
    };
    reader.readAsText(file);
  }

  function today() { // AAAA-MM
    try { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2); }
    catch (_) { return ''; }
  }

  /* ---------- Init ---------- */
  function init() {
    el.select = $('profileSelect'); el.verdict = $('verdict');
    el.new = $('btnProfNew'); el.dup = $('btnProfDup');
    el.import = $('btnProfImport'); el.export = $('btnProfExport');
    el.file = $('profFile'); el.editor = $('profEditor');
    el.json = $('profJson'); el.save = $('btnProfSave');
    el.cancel = $('btnProfCancel'); el.msg = $('profEditMsg');
    if (!el.select) return;

    populate();
    el.select.addEventListener('change', function () { selectedId = el.select.value || null; closeEditor(); evaluateAndRender(); });
    el.new.addEventListener('click', newProfile);
    el.dup.addEventListener('click', duplicate);
    el.export.addEventListener('click', exportProfile);
    el.import.addEventListener('click', function () { el.file.click(); });
    el.file.addEventListener('change', function () { if (el.file.files[0]) { importProfile(el.file.files[0]); el.file.value = ''; } });
    el.save.addEventListener('click', saveEdited);
    el.cancel.addEventListener('click', closeEditor);
    updateButtons();
  }

  window.ProfilesUI = {
    apply: function (m) { model = m; evaluateAndRender(); },
    // rapport du profil sélectionné, null sans profil
    report: function () { return lastReport; },
    onReport: function (fn) { listeners.push(fn); },
    allProfiles: function () { return allProfiles(); },
    currentId: function () { return selectedId; },
    evaluateWith: function (id, m) { var p = byId(id); return p && m ? R.evaluate(p, m) : null; },
    setSelected: function (id) { selectedId = id || null; if (el.select) el.select.value = selectedId || ''; evaluateAndRender(); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
